'use strict';
import React, { Component } from 'react';
import ModalMensaje from '../../../Common/Components/ModalMensaje';

class MaxwellIA extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        this.props.cargarSSOUrl(this.props.email, this.props.nombre);
    }

    render() {
        const { ssoUrl, error } = this.props;

        if (error) {
            return (
                <ModalMensaje
                    mensaje={error}
                    titulo={"Maxwell IA"}
                    mostrarOcultarModal={this.props.mostrarOcultarModal}
                />
            );
        }

        if (!ssoUrl) {
            return (
                <div style={{ position: 'fixed', top: '132px', left: '16px', background: '#fff3cd', padding: '12px', borderRadius: '4px', border: '1px solid #ffc107' }}>
                    Maxwell IA: generando token SSO...
                </div>
            );
        }

        return (
            <iframe
                src={ssoUrl}
                style={{ position: 'fixed', top: '128px', left: 0, right: 0, bottom: 0, width: '100%', height: 'calc(100vh - 128px)', border: 'none' }}
                title="Maxwell IA"
            />
        );
    }
}

export default MaxwellIA;
